<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Agents</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <ul class="agents">
        <li v-for="agent in agents" :key="agent.id" class="agents__row">
          <div class="agents__info">
            <strong class="agents__name">{{ agent.data().name }}</strong>
            <small class="agents__number">{{ agent.data().number }}</small>
          </div>
          <a class="button is-success" :href="`tel:${agent.data().number}`" :aria-label="`Call ${agent.data().name}`">
            <b-icon icon="phone"></b-icon>
          </a>
          <b-button v-if="del" type="is-danger" icon-right="delete" :aria-label="`Delete ${agent.data().name}`" @click="deleteAgent(agent.id)" />
        </li>
      </ul>
      <p v-if="!agents.length" class="tb-empty">No agents to show.</p>
    </section>
  </div>
</template>

<script>
  import "firebase/firestore";
  import firebase from "firebase/app";

  export default {
    name: "AgentList",
    props: {
      // Admins get a delete control next to each agent.
      del: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        agents: []
      };
    },
    methods: {
      async fetchAgentList() {
        const agents = await firebase.firestore().collection("agents").orderBy("name", "asc").get();
        this.agents = agents.docs;
      },
      deleteAgent(uid) {
        this.$emit("DelAgent", uid);
        this.$parent.close();
      }
    },
    mounted() {
      this.fetchAgentList();
    }
  };
</script>

<style scoped>
  .agents {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .agents__row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border: 1px solid var(--tb-line);
    border-radius: 12px;
    background: var(--tb-surface);
  }

  .agents__info {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    text-align: left;
  }

  .agents__name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .agents__number {
    color: var(--tb-ink-soft);
    font-weight: 400;
    font-variant-numeric: tabular-nums;
  }

  .agents__row .button {
    min-width: 44px;
    min-height: 44px;
  }
</style>
